import NTopNBottom from '../../components/NTopNBottom'

import navColor from '../../assets/birthday/nav/color.png'
import navBg from '../../assets/birthday/nav/nav_bg.png'

import far1 from '../../assets/birthday/nav/far1.png'
import far1_active from '../../assets/birthday/nav/far1_active.png'
import far2 from '../../assets/birthday/nav/far2.png'
import far2_active from '../../assets/birthday/nav/far2_active.png'
import far3 from '../../assets/birthday/nav/far3.png'
import far3_active from '../../assets/birthday/nav/far3_active.png'
import son1 from '../../assets/birthday/nav/son1.png'
import son1_active from '../../assets/birthday/nav/son1_active.png'
import son2 from '../../assets/birthday/nav/son2.png'
import son2_active from '../../assets/birthday/nav/son2_active.png'
import son3 from '../../assets/birthday/nav/son3.png'
import son3_active from '../../assets/birthday/nav/son3_active.png'
import son4 from '../../assets/birthday/nav/son4.png'
import son4_active from '../../assets/birthday/nav/son4_active.png'
import son5 from '../../assets/birthday/nav/son5.png'
import son5_active from '../../assets/birthday/nav/son5_active.png'
import son6 from '../../assets/birthday/nav/son6.png'
import son6_active from '../../assets/birthday/nav/son6_active.png'
import son7 from '../../assets/birthday/nav/son7.png'
import son7_active from '../../assets/birthday/nav/son7_active.png'
import son8 from '../../assets/birthday/nav/son8.png'
import son8_active from '../../assets/birthday/nav/son8_active.png'

import bannerImg from '../../assets/birthday/banner.gif'

import p1_1 from '../../assets/birthday/ctn/1_1.jpg'
import p1_2 from '../../assets/birthday/ctn/1_2.jpg'
import p1_3 from '../../assets/birthday/ctn/1_3.jpg'
import p1_4 from '../../assets/birthday/ctn/1_4.jpg'
import p1_5 from '../../assets/birthday/ctn/1_5.jpg'
import p2_1 from '../../assets/birthday/ctn/2_1.jpg'
import p2_2 from '../../assets/birthday/ctn/2_2.jpg'
import p2_3 from '../../assets/birthday/ctn/2_3.jpg'
import p3_1 from '../../assets/birthday/ctn/3_1.jpg'
import p3_2 from '../../assets/birthday/ctn/3_2.jpg'
import p3_3 from '../../assets/birthday/ctn/3_3.jpg'
import p3_4 from '../../assets/birthday/ctn/3_4.jpg'
import p3_5 from '../../assets/birthday/ctn/3_5.jpg'

const IS_PROD = process.env.VUE_APP_ENV_MICRO === 'production'

import calcRemFn from '../calcRem'


// 需要手动修改proId
const top1_i1 = IS_PROD ? '94215' : '94215'
const top1_i2 = top1_i1
const top1_i3 = top1_i1
const top2_i1 = IS_PROD ? '96910' : '96910'
const top2_i2 = top2_i1
const top2_i3 = top2_i1
const top3_i1 = IS_PROD ? '94216' : '94216'
const top3_i2 = top3_i1
const top3_i3 = top3_i1
const top3_i4 = top3_i1

const navCss = {
  navWrap: {
    minHeight: calcRemFn(128),
    backgroundImage: `url(${navColor})`,
  },
  navCtn: {
    height: calcRemFn(128),
    backgroundImage: `url(${navBg})`,
  },
  topBtnLayout: {
    padding: `${calcRemFn(15)} ${calcRemFn(5)} 0`,
  },
  topBtnBaseCss: {
    width: calcRemFn(120),
    height: calcRemFn(58),
  },
  bottomBtnLayout: {
    padding: `${calcRemFn(18)} ${calcRemFn(30)} 0`,
  },
  bottomBtnBaseCss: {
    width: calcRemFn(48),
    height: calcRemFn(18),
  },
}

const navData = {
  component: NTopNBottom,
  top: [
    {
      key: 'top1',
      show: true,
      img: far1,
      img_actived: far1_active,
    },
    {
      key: 'top2',
      show: true,
      img: far2,
      img_actived: far2_active,
    },
    {
      key: 'top3',
      show: true,
      img: far3,
      img_actived: far3_active,
    }
  ],
  bottom: {
    top1: [
      {
        key: '_i1',
        show: true,
        img: son1,
        img_actived: son1_active,
        prodId: top1_i1
      },
      {
        key: '_i2',
        show: true,
        img: son2,
        img_actived: son2_active,
        prodId: top1_i2
      },
      {
        key: '_i3',
        show: true,
        img: son3,
        img_actived: son3_active,
        prodId: top1_i3
      },
      {
        key: '_i4',
        show: true,
        img: son4,
        img_actived: son4_active,
        prodId: top1_i2
      },
      {
        key: '_i5',
        show: true,
        img: son5,
        img_actived: son5_active,
        prodId: top1_i3
      }
    ],
    top2: [
      {
        key: '_i1',
        show: true,
        img: son6,
        img_actived: son6_active,
        prodId: top2_i1
      },
      {
        key: '_i2',
        show: true,
        img: son7,
        img_actived: son7_active,
        prodId: top2_i2
      },
      {
        key: '_i3',
        show: true,
        img: son8,
        img_actived: son8_active,
        prodId: top2_i3
      },
    ],
    top3: [
      {
        key: '_i1',
        show: true,
        img: son1,
        img_actived: son1_active,
        prodId: top3_i1
      },
      {
        key: '_i2',
        show: true,
        img: son2,
        img_actived: son2_active,
        prodId: top3_i2
      },
      {
        key: '_i3',
        show: true,
        img: son3,
        img_actived: son3_active,
        prodId: top3_i3
      },
      {
        key: '_i4',
        show: true,
        img: son4,
        img_actived: son4_active,
        prodId: top3_i4
      },
      {
        key: '_i5',
        show: true,
        img: son5,
        img_actived: son5_active,
        prodId: top3_i4
      },
    ]
  }
}

const pictures = [
  {
    id: top1_i1,
    type: 'blue',
    ref: 'top1_i1',
    farName: 'top1',
    sonName: '_i1',
    son: [
      p1_1,
    ],
  },
  {
    id: top1_i2,
    type: 'blue',
    ref: 'top1_i2',
    farName: 'top1',
    sonName: '_i2',
    son: [
      p1_2,
    ]
  },
  {
    id: top1_i3,
    type: 'blue',
    ref: 'top1_i3',
    farName: 'top1',
    sonName: '_i3',
    son: [
      p1_3,
    ]
  },
  {
    id: top1_i3,
    type: 'blue',
    ref: 'top1_i4',
    farName: 'top1',
    sonName: '_i4',
    son: [
      p1_4,
    ]
  },
  {
    id: top1_i3,
    type: 'blue',
    ref: 'top1_i5',
    farName: 'top1',
    sonName: '_i5',
    son: [
      p1_5,
    ]
  },
  {
    id: top2_i1,
    type: 'blue',
    ref: 'top2_i1',
    farName: 'top2',
    sonName: '_i1',
    son: [
      p2_1,
    ]
  },

  {
    id: top2_i2,
    type: 'blue',
    ref: 'top2_i2',
    farName: 'top2',
    sonName: '_i2',
    son: [
      p2_2,
    ]
  },
  {
    id: top2_i3,
    type: 'blue',
    ref: 'top2_i3',
    farName: 'top2',
    sonName: '_i3',
    son: [
      p2_3
    ]
  },

  {
    id: top3_i1,
    type: 'blue',
    ref: 'top3_i1',
    farName: 'top3',
    sonName: '_i1',
    son: [
      p3_1
    ]
  },
  {
    id: top3_i2,
    type: 'blue',
    ref: 'top3_i2',
    farName: 'top3',
    sonName: '_i2',
    son: [
      p3_2,
    ]
  },
  {
    id: top3_i3,
    type: 'blue',
    ref: 'top3_i3',
    farName: 'top3',
    sonName: '_i3',
    son: [
      p3_3,
    ]
  },
  {
    id: top3_i4,
    type: 'blue',
    ref: 'top3_i4',
    farName: 'top3',
    sonName: '_i4',
    son: [
      p3_4,
    ]
  },
  {
    id: top3_i4,
    type: 'blue',
    ref: 'top3_i5',
    farName: 'top3',
    sonName: '_i5',
    son: [
      p3_5,
    ]
  }
]

const topDiff = {
  firstSon: '_i1',
}

export default {
  title: '愿望城堡',
  bannerImg,
  navCss,
  navData,
  pictures,
  topDiff
}
